import React from 'react';
import { Button, Result } from 'antd';
import PropTypes from 'prop-types';

import useStores from '$src/hooks/useStores';
import {handleBackToRingDashboard} from '$src/utils/handleBack';
import {sendCloudwatchRUMError} from '../../utils/cloudwatchRUM';

function withIsMobile(Component) {
  return function WrappedComponent(props) {
  const { sessionStore: { isMobile }} = useStores();
    return <Component {...props} isMobile={isMobile} />;
  };
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    this.setState({ error });
    sendCloudwatchRUMError('Message caught by ErrorBoundary', error, true) 
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="500"
          title="There was a problem"
          subTitle="Sorry, something went wrong."
          extra={
            <Button type="primary" onClick={() => handleBackToRingDashboard(this.props.isMobile)}>
              Back to Control Center
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isMobile: PropTypes.bool,
};

export default withIsMobile(ErrorBoundary);
